import { OrganizationType, OrganizationTypeToOrganizationReviewsMap } from '../constants/organizationType';
import type { ISravniReviewsRatingModel } from '../interfaces/rating';
import type { ICellItem } from '../interfaces/ratingTable';

export const normalizeDataForTable = (data: ISravniReviewsRatingModel[]): ICellItem[] => {
  return data.map((item) => {
    const {
      organizationType,
      organizationName,
      organizationAlias,
      complexCalculatedRatingValue,
      participantsCount, // количество непроаппрувленных отзывов
      approved,
      withAnswers,
      resolved,
      responseTimeTicks,
      squareLogo,
      roundLogo,
      logo,
      isPartner,
    } = item;

    const organizationPath = OrganizationTypeToOrganizationReviewsMap[organizationType];
    const alias = organizationAlias;

    return {
      name: organizationName,
      rating: complexCalculatedRatingValue,
      reviewsCount: participantsCount,
      responseCount: withAnswers,
      numberOfRatings: approved,
      solvedProblems: resolved,
      responseSpeed: {
        days: Math.floor(responseTimeTicks / (24 * 60 * 60 * 10000000)),
        hours: Math.round((responseTimeTicks / (60 * 60 * 10000000)) % 24),
      },
      companyUrl: `/${organizationPath}/${alias}/`,
      reviewsUrl: `/${organizationPath}/${alias}/otzyvy/`,
      responseUrl: `/${organizationPath}/${alias}/otzyvy/?rated=good&filterBy=withAnswers`,
      solvedProblemsUrl: `/${organizationPath}/${alias}/otzyvy/?rated=good&filterBy=resolved`,
      squareLogoUrl: squareLogo,
      roundLogoUrl: roundLogo,
      logoUrl: logo,
      organizationType: organizationType as unknown as OrganizationType,
      isPartner,
    };
  });
};
